import React, { Component } from 'react'
import PlaylistItem from './PlaylistItem'
import SimpleBar from 'simplebar-react';
import 'simplebar/dist/simplebar.min.css';
import { Resizable } from "re-resizable";
import { inject, observer } from 'mobx-react'

@inject('playlistStore')
@observer

class Playlist extends Component {
  constructor(props) {
    super(props)
    this.playlistMexHeight = 650;
  }

  componentDidMount() {
    this.props.playlistStore.sync();
  }

  renderPlaylistItems() {
    const items = this.props.playlistStore.items
    if (items.length == 0) {
      this.props.onCleared()
    }

    return items.map( (item, index) => {
      return (
        <PlaylistItem key={index} item={item} />
      )
    })
  }

  render() {
    if(this.props.playlistStore.items.length == 1) {
      return this.renderPlaylist()
    } else {
      return this.renderPlaylistWithScroll()
    }
  }

  renderPlaylist() {
    return (
      <div>
        { this.renderPlaylistItems() }
      </div>
    )
  }

  get maxHeight() {
    let height = this.props.playlistStore.items.length * 65;
    return height > this.playlistMexHeight ? this.playlistMexHeight : height;
  }

  renderPlaylistWithScroll() {
    return (
      <Resizable
        className='hidden md:block playlist'
        handleClasses={{ top: 'playlist-top-handle' }}
        minHeight='65'
        maxHeight={this.maxHeight}
        defaultSize={{ height: this.maxHeight }}
        enable={{top:true, right:false, bottom:false, left:false, topRight:false, bottomRight:false, bottomLeft:false, topLeft:false }}
      >
        <SimpleBar autoHide="false" forceVisible="y" className='max-h-full'>
          { this.renderPlaylistItems() }
        </SimpleBar>
      </Resizable>
    )
  }
}

export default Playlist
